import React, { useState, useEffect } from "react";
import { Skeleton } from "@mui/material";

export const useSkeletonLoader = (loading: boolean) => {
  const [skeletonVisible, setSkeletonVisible] = useState(false);

  useEffect(() => {
    if (loading) {
      setSkeletonVisible(true);
    } else {
      const timer = setTimeout(() => setSkeletonVisible(false), 300);
      return () => clearTimeout(timer);
    }
  }, [loading]);

  const loadWithSkeleton = (element: React.ReactNode) => {
    if (skeletonVisible) {
      return (
        <Skeleton
          animation="wave"
          variant="rounded"
          width={"100%"}
          height={56}
        />
      );
    }
    return element;
  };

  return { loadWithSkeleton };
};
